import {Swiper} from 'swiper'

// media and content slider
let financialSlider = $('.js-financial-news-block')
if (financialSlider.length){

  financialSlider.each((i, block)=> {

    let slider = $(block).find('.js-slider')
    let nextB = $(block).find('.js-next-slide')
    let prevB = $(block).find('.js-prev-slide')
    let swiper

    let swiperParams = {
      slidesPerView: 1,
      spaceBetween: 15,
      loop: false,
      breakpoints: {
        1800: {
          slidesPerView: 5,
        },
        1200: {
          slidesPerView: 4,
          spaceBetween: 0,
        },
        900: {
          slidesPerView: 3,
        },
        700: {
          slidesPerView: 2,
        },
      },
      // autoplay: {
      //   delay: 4000,
      // },
      // speed: 400
    }


    // Slider
    function initSlider(initSlider){
      swiper = new Swiper(initSlider, swiperParams);

      // navigation buttons
      nextB.click(()=> swiper.slideNext() )
      prevB.click(()=> swiper.slidePrev() )

      // slide change event
      swiper.on('slideChange', (slider)=> {
        disableNavButtons(slider)
      });

    }

    function disableNavButtons(slider){
      slider.isEnd ? nextB.addClass('disabled') : nextB.removeClass('disabled')
      slider.isBeginning ? prevB.addClass('disabled') : prevB.removeClass('disabled')
    }

    initSlider(slider[0])


  })

}
